import type {
  GroupBase,
  Props,
  SelectComponent,
  SelectInstance
} from 'chakra-react-select';

import {
  Select
} from 'chakra-react-select';
import type { MutableRefObject } from 'react';
import { forwardRef } from 'react';
import MultiValue from './components/MultiValue';
import Option from './components/Option';
import ValueContainer from './components/ValueContainer';


const CheckboxSelect = forwardRef(
  <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
    props: Props<Option, IsMulti, Group>,
    ref:
      | ((instance: SelectInstance<Option, IsMulti, Group> | null) => void)
      | MutableRefObject<SelectInstance<Option, IsMulti, Group> | null>
      | null
  ) => {
    return (
      <Select 
        ref={ref}
        isMulti={true as IsMulti}
        chakraStyles={{
          control: (baseStyles, state) => {
            //console.log('baseStyles', baseStyles);
            //console.log('state', state)
            return {
              ...baseStyles,
              //...(state.isFocused && state.selectProps.inputValue.trim().length > 0 && {
                ...(state.isFocused && {
                '.custom-rendered-value': {
                  display: 'none'
                }
              })
            }
          },
          container: (props) => ({
            ...props,
            minW: '250px'
          }),
          placeholder: (props) => ({
            ...props,
            display: 'none'
          }),
          option: (props) => ({
            ...props,
            fontWeight: 400,
            fontSize: '14px',
            '> span': {
              opacity: 0
            }
          }),
          clearIndicator: (props) => ({
            ...props,
            pos: 'absolute',
            bgColor: 'white',
            right: '33px'
          }),
        }}
        hideSelectedOptions={false}
        controlShouldRenderValue={false}
        //delimiter=','
        //isClearable={false}
        selectedOptionStyle="check"
        name="filterCustomer"
        //components={{ Group, GroupHeading, ValueContainer }}
        components={{ ValueContainer, MultiValue, Option }}
        backspaceRemovesValue={false}
        closeMenuOnSelect={false}
        //closeMenuOnSelect={false} blurInputOnSelect={false}
        noOptionsMessage={() => 'Nenhum resultado encontrado'}
        {...props}
      />
    );
  }
) as SelectComponent;

export default CheckboxSelect;
